import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleHeart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubbleHeart"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V19H15.2858L11.9951 21.7263L8.74274 19H3V3ZM11.9994 14.2802C11.9994 14.2802 15.2507 13.0001 15.2507 10.6676C15.2507 8.91956 13.5031 7.87886 11.9994 8.85008C10.4957 7.87886 8.74805 8.91956 8.74805 10.6676C8.74805 13.0001 11.9994 14.2802 11.9994 14.2802Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleHeart;
